import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
import HomeTestimonials from './home/HomeTestimonials'
import HomeBlog from './home/HomeBlog'
import OurBenefits from './home/OurBenefits'
import WhyChoose from './home/WhyChoose'
import FreshJourney from './home/FreshJourney'
import OurCertificate from './home/OurCertificate'
import Product from './product/Product'
import HomeGallery from './home/HomeGallery'
import Uses from './home/Uses'
import HomeVideo from './home/HomeVideo'



const Home = () => {
  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <HomeBanner />
        <Uses />
        <Product />
        <HomeAbout />
        <HomeVideo />
        <OurBenefits />
        <WhyChoose />
        <HomeGallery />
        <FreshJourney />
        <OurCertificate />
        <HomeTestimonials />

      </div>






    </>
  )
}

export default Home